var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDragHandles = function SvgDragHandles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2s-.9 2-2 2H3c-1.1 0-2-.9-2-2zM1 14c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2s-.9 2-2 2H3c-1.1 0-2-.9-2-2z"
  })));
};
export default SvgDragHandles;